export const calculationInputQuery = `mutation Calculate($input: CalculateInput!) { 
  calculate(input: $input) { 
    calculationResult { 
      policyDetails { 
        totalInstallmentAmount 
        effectiveDate 
        grossPremiumInstallment 
        surchargesInstallmentAmount 
        discountsInstallmentAmount 
        netPremiumInstallment 
        costsInstallmentAmount 
        insuranceTaxInstallmentAmount 
        paymentTermInMonths 
        renewalCommissionInstallmentAmount 
        productDescription 
        porCompany
        companyNameDescription
        refKey
        orderFormId
        productCode
        conditionConditionDetails { 
          conditionNumber
          conditionText
          url
        } 
        masterAgreementPackages { 
          productDescription 
        } 
        objectMotorVehicles { 
            licensePlate 
            reportCode 
            text
            annualMileage
            constructionYear
            initialListPrice
            currentValueAmount
            rdwVehicleCategory
            advice
            reason
            coverageThirdPartyLiabilities {
                productDescription
            }
            partyRegularDrivers {
                numberOfClaimFreeYears
            }
            coverageHullVehicles {
                deductibleAmount
                productDescription
                sumInsured
            }
            documents {
                urlAttachment
                attachmentDescription
            }
        }
        documents {
            attachmentDescription
            urlAttachment
        }
        customProperties {
            supplierKrn
        }
      }
      commonTechnical {
        accessCode
        transactionReference
        senderId
        sessionId
      }
    } 
  } 
}`;
